/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */

import React from 'react';
import clsx from 'clsx';
import style from './RiepilogoForm.module.scss';
import store from '../../../../app/store/store';

function PoltroneForm() {
  return (

    <div className={clsx(style.form)}>
      <div className={clsx(style.form__header)}>
        <h2 className={clsx(style.page__title)}>
          {' '}
        </h2>
        <h3 className={clsx(style.page__subtitle)}>
          Grazie per la registrazione
          {` ${store.getState().form.form.userName}`}
          , stiamo preparando la tua app. Verrai contattato da Cristian o Valentina appena sarà pronta. (Entro 48 ore)
        </h3>

      </div>
    </div>

  );
}

export default PoltroneForm;
